<template>
  <el-form ref="pwdRef" :model="user" :rules="rules" label-width="80px">
    <el-form-item label="旧密码" prop="oldPassword">
      <el-input
        v-model="user.oldPassword"
        placeholder="请输入旧密码"
        type="password"
        show-password
        inputStyle="{'background':'red'}"
        style="{'background':'red'}"
      />
    </el-form-item>
    <el-form-item label="新密码" >
      <el-input
        v-model="user.password"
        placeholder="请输入新密码"
        type="password"
        show-password
      />
    </el-form-item>
    <el-form-item label="确认密码" prop="confirmPassword">
      <el-input
        v-model="user.confirmPassword"
        placeholder="请确认新密码"
        type="password"
        show-password
      />
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="submit">保存</el-button>
    </el-form-item>
  </el-form>
</template>

<script setup>
import UserApi from "@/api/UserApi";
import { getCurrentInstance, reactive, ref } from "vue";
import { ElMessage } from "element-plus";
import { currentUser,updatePassword } from "@/api/Login";
const { proxy } = getCurrentInstance();

const user = reactive({
  oldPassword: undefined,
  password: undefined,
  confirmPassword: undefined,
});

const equalToPassword = (rule, value, callback) => {
  if (user.password !== value) {
    callback(new Error("两次输入的密码不一致"));
  } else {
    callback();
  }
};
let pwdValidate = (rule, value, callback) => {
      if (/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[._~!@#$^&*])[A-Za-z0-9._~!@#$^&*]{8,16}$/g.test(value)) {
        callback()
      } else {
        callback(new Error('请输入包含英文字母大小写、数字和特殊符号的 8-16 位组合'))
      }
}

const rules = ref({
  oldPassword: [{ required: true, message: "旧密码不能为空", trigger: "blur" }],
  newPassword: [
    { required: true, message: "新密码不能为空", trigger: "blur" },
    { min: 6, max: 20, message: "长度在 6 到 20 个字符", trigger: "blur" },
    { validator: pwdValidate, trigger: 'blur' }
  ],
  confirmPassword: [
    { required: true, message: "确认密码不能为空", trigger: "blur" },
    { required: true, validator: equalToPassword, trigger: "blur" },
  ],
});

/** 提交按钮 */
function submit() {
  proxy.$refs.pwdRef.validate((valid) => {
    if (valid) {
      updatePassword({oldPassword:user.oldPassword, password:user.password}).then(() => {
        user.oldPassword = undefined;
        user.password = undefined;
        user.confirmPassword = undefined;
        ElMessage.success("修改成功");
      });
    }
  });
}
</script>
<style scoped>
.el-input{
    --el-input-focus-border-color:#222222;
    --el-input-bg-color:#222222;
    --el-input-border-color:#222222;
    --el-border-color-hover:#222222;
    --el-input-text-color:#fff;
}
</style>
